import { LOCATION_CHANGE } from 'connected-react-router';
import { delay } from 'redux-saga';
import { all, call, fork, put, select, spawn, take } from 'redux-saga/effects';
import { clearMessage, SET_MESSAGE, unsetMessage } from './actions';
import { getMessage } from './selectors';

/* eslint-disable no-constant-condition */
function* expireMessage(id, delayMilliseconds, slotId) {
  yield call(delay, delayMilliseconds);
  yield put(unsetMessage(id, slotId));
}

function* watchMessageSet() {
  while (true) {
    const { slotId, timeout } = yield take(SET_MESSAGE);

    if (timeout) {
      const { id } = yield select(getMessage, { slotId });

      yield fork(expireMessage, id, timeout, slotId);
    }
  }
}

function* watchFormLeave() {
  while (true) {
    yield take(LOCATION_CHANGE);
    const hasMessage = yield select(getMessage);
    if (hasMessage) {
      yield put(clearMessage());
    }
  }
}

export default function* root() {
  yield all([
    spawn(watchMessageSet),
    spawn(watchFormLeave)
  ]);
}
/* eslint-enable no-constant-condition */
